import React from "react";
import CasoChecket from "../../../assets/images/check.svg";
import { TbCheck } from "react-icons/tb";

const ConfirmationStep = ({
  appointmentConfirmed,
  selectedAppointment,
  patientInfo,
  doctorInfo,
  locationInfo,
  uploadedDocuments,
  onConfirmAppointment,
  onResetForm,
  onBack
}) => {
  console.log(patientInfo, doctorInfo, locationInfo, uploadedDocuments);
  return (
    <div className="step-content_">
      {appointmentConfirmed ? (
        <div className="confirmation-success">
          <div className="success-icon">
            <img
              style={{ width: "100px", height: "100px" }}
              src={CasoChecket}
              alt=""
            />
          </div>
          <h3 style={{ fontSize: "1.3rem", marginBottom: "1.8rem" }}>
            ¡Cita Confirmada!
          </h3>

          <div className="appointment-details">
            <div className="detail-card card_background">
              <div className="detail-header">Detalles de la cita</div>
              <div className="detail-item">
                <span>Sede:</span>
                <strong>{locationInfo.nombre}</strong>
              </div>
              <div className="detail-item">
                <span>Fecha:</span>
                <strong>{selectedAppointment.date}</strong>
              </div>
              <div className="detail-item">
                <span>Hora:</span>
                <strong>{selectedAppointment.time} - </strong>
              </div>
              <div className="detail-item">
                <span>Doctor:</span>
                <strong>Dr. {doctorInfo.get_full_name}</strong>
              </div>
              <div className="detail-item">
                <span>Email:</span>
                <strong>{doctorInfo.username}</strong>
              </div>
            </div>

            <div className="detail-card card_background">
              <div className="detail-header">Datos del paciente</div>
              <div className="detail-item">
                <span>Nombre:</span>
                <strong>{patientInfo.name}</strong>
              </div>
              <div className="detail-item">
                <span>Identificación:</span>
                <strong>{patientInfo.documentNumber}</strong>
              </div>
              <div className="detail-item">
                <span>Telefono:</span>
                <strong>{patientInfo.phone}</strong>
              </div>
              {patientInfo.reason ? (
                <div className="detail-item">
                  <span>Motivo de la cita:</span>
                  <strong>{patientInfo.reason}</strong>
                </div>
              ) : null}
              <div className="detail-item">
                <span className="mx-1">Email: </span>
                <strong>
                  {patientInfo.email ? patientInfo.email : "Sin email"}
                </strong>
              </div>
            </div>
          </div>

          <button className="finish-btn" onClick={onResetForm}>
            Agendar una nueva cita
          </button>
        </div>
      ) : (
        <div className="confirmation-pending">
          <h3 className="step-title" style={{ marginBottom: "1.8rem" }}>
            Confirmar Cita
          </h3>
          <div className="appointment-summary">
            <div className="summary-card  card_background">
              <div className="summary-header">Resumen de la cita</div>
              <div className="summary-item">
                <span>Sede:</span>
                <strong>{locationInfo.nombre}</strong>
              </div>
              <div className="summary-item">
                <span>Fecha:</span>
                <strong>{selectedAppointment.date}</strong>
              </div>
              <div className="summary-item">
                <span>Hora:</span>
                <strong>{selectedAppointment.time} - </strong>
              </div>
              <div className="summary-item">
                <span>Doctor:</span>
                <strong>Dr. {doctorInfo.get_full_name}</strong>
              </div>
              <div className="summary-item">
                <span>Email:</span>
                <strong>{doctorInfo.username}</strong>
              </div>
            </div>

            <div className="summary-card card_background">
              <div className="summary-header">Datos del paciente</div>
              <div className="summary-item">
                <span>Nombre:</span>
                <strong>{patientInfo.name}</strong>
              </div>
              <div className="summary-item">
                <span>Identificación:</span>
                <strong>{patientInfo.documentNumber}</strong>
              </div>
              <div className="summary-item">
                <span>Telefono:</span>
                <strong>{patientInfo.phone}</strong>
              </div>
              {patientInfo.reason ? (
                <div className="summary-item">
                  <span>Motivo de la cita:</span>
                  <strong>{patientInfo.reason}</strong>
                </div>
              ) : null}
              <div className="summary-item">
                <span className="mx-1">Email: </span>
                <strong>
                  {patientInfo.email ? patientInfo.email : "Sin email"}
                </strong>
              </div>
            </div>
          </div>
          {uploadedDocuments.length > 0 && (
            <div className="detail-card">
              <div className="detail-header">Documentos adjuntos</div>
              {uploadedDocuments.map((doc) => (
                <div key={doc.id} className="detail-item document-item">
                  {doc.type.startsWith("image/") && (
                    <img
                      src={doc.base64}
                      alt={doc.name}
                      className="document-preview"
                    />
                  )}
                  <div>
                    <strong>{doc.name}</strong>
                    <div style={{ fontSize: "0.8rem", color: "#666" }}>
                      {(doc.size / 1024).toFixed(1)} KB
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="form-actions">
            <button className="back-btn" onClick={onBack}>
              Volver
            </button>
            <button className="confirm-btn" onClick={onConfirmAppointment}>
              <span>Confirmar cita</span>
              <span style={{ marginRight: "-.5rem" }}>
                <TbCheck size={21} />
              </span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmationStep;
